import api from '../api'

const initialState = {
  expired: true,
  error: null,
  userName: null,
  loggingIn: false,
  loggedIn: false,
  role: null,
  creatingRoot: false,
  createRootError: null,
  userId: 0,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case api.login.request:
      return {
        ...state,
        loggingIn: true,
      }
    case api.login.success: {
      const { role, userId, userName } = action.payload
      return {
        ...state,
        expired: false,
        loggingIn: false,
        loggedIn: true,
        role, userId, userName,
      }
    }
    case api.login.failure:
      return {
        ...state,
        expired: true,
        loggingIn: false,
        loggedIn: false,
        error: 'Invalid credentials',
      }
    case api.createRoot.request:
      return {
        ...state,
        creatingRoot: true,
      }
    case api.createRoot.success: {
      return {
        ...state,
        creatingRoot: false,
        createRootError: null,
      }
    }
    case api.createRoot.failure:
      return {
        ...state,
        creatingRoot: false,
        createRootError: 'Error',
      }
    case api.logout.success:
      return initialState
    case api.getSessionStatus.success: {
      const { role, userId, userName } = action.payload
      return {
        ...state,
        loggedIn: true,
        expired: false,
        role, userId, userName,
      }
    }
    case 'sessionExpired':
    case api.getSessionStatus.failure:
      return {
        ...state,
        expired: true,
        loggedIn: false,
      }
    default:
      return state
  }
}
